import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getFinansistCatalogProjects } from "../../../api/timesheetApi";
import { normalizeFinansistCatalogProjects } from "../../../utils/finansistPayrollMapping";

const FinansistPayrollMapping = ({
  variant = "editproject",
  value,
  onChange,
  selectStyles,
}) => {
  const [catalogLoading, setCatalogLoading] = useState(true);
  const [catalogError, setCatalogError] = useState("");
  const [finansistProjects, setFinansistProjects] = useState([]);

  const pointClass = `${variant}__point`;
  const titleClass = `${variant}__point-title`;

  useEffect(() => {
    let cancelled = false;

    const loadCatalog = async () => {
      setCatalogLoading(true);
      setCatalogError("");
      try {
        const projectsRaw = await getFinansistCatalogProjects({
          allPages: true,
          maxPages: 100,
        });
        if (cancelled) return;
        setFinansistProjects(normalizeFinansistCatalogProjects(projectsRaw));
      } catch (err) {
        if (!cancelled) {
          setCatalogError(
            err.message || "Не удалось загрузить проекты Finansist",
          );
        }
      } finally {
        if (!cancelled) {
          setCatalogLoading(false);
        }
      }
    };

    loadCatalog();
    return () => {
      cancelled = true;
    };
  }, []);

  // После загрузки каталога обновить label из справочника для уже привязанного проекта
  useEffect(() => {
    const selected = value?.finansistProject;
    if (!selected?.value || !finansistProjects.length) return;

    const fromCatalog = finansistProjects.find(
      (p) => Number(p.value) === Number(selected.value),
    );
    if (fromCatalog && fromCatalog.label !== selected.label) {
      onChange({ finansistProject: fromCatalog });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- только при появлении каталога
  }, [finansistProjects]);

  return (
    <li className={pointClass}>
      <span className={titleClass}>Проект Finansist</span>
      <Select
        options={finansistProjects}
        value={value.finansistProject}
        onChange={(opt) => onChange({ finansistProject: opt })}
        styles={selectStyles(false)}
        placeholder={
          catalogLoading ? "Загрузка..." : "Выберите проект Finansist"
        }
        isLoading={catalogLoading}
        isClearable
        isDisabled={catalogLoading || !!catalogError}
        noOptionsMessage={() => "Проекты не найдены"}
      />
      {catalogError && (
        <span className={`${variant}__error-message`}>{catalogError}</span>
      )}
    </li>
  );
};

export default FinansistPayrollMapping;
